import React from "react";
import { Link } from "react-router-dom";

export default function BannerHero() {
  return (
    <section className="relative w-full h-[70vh] min-h-[640px] overflow-hidden bg-slate-950">
      
      {/* Background Video */}
      <video
        src="/videos/hdlabs-dna.mp4"
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover scale-105"
      />

      {/* Soft Blue Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-blue-950/70 to-blue-900/60" />

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center h-full max-w-5xl mx-auto px-6 sm:px-12 text-white">

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold leading-tight tracking-tight max-w-3xl">
          Lab-Grade Purity.
          <br />
          Consistency You Can Trust.
        </h1>

        {/* Subtext */}
        <p className="mt-6 text-lg text-blue-100/80 max-w-xl">
          High-purity compounds manufactured under strict quality standards and verified independently.
        </p>

        {/* CTA Button */}
<div className="mt-10">
  <Link
    to="/shop"
    className="
      inline-flex items-center justify-center 
      rounded-2xl 
      bg-gradient-to-r from-blue-700 via-blue-800 to-blue-900 
      text-white px-8 py-4 text-lg font-semibold 
      shadow-lg 
      transform transition-all duration-300 
      hover:scale-105 hover:shadow-xl hover:from-blue-500 hover:via-blue-600 hover:to-blue-700 
      focus:outline-none focus:ring-4 focus:ring-blue-300
    "
  >
    View Products
  </Link>
</div>

      </div>

    </section>
  );
}